import AjaxUtils from './ajaxUtils';

const fetchUgcData = async (query = '') => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/ugc/data?${query}`, true);
const fetchUgcSettings = async (query = '') => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/ugc/settings?${query}`, true);
const sendUserAnswer = async data => AjaxUtils.post(`${envConfig.PLATFORM_SERVER_URL}/v2/ugc/data`, data, true, true);
const updateUgcSettings = async (id = '', data) => AjaxUtils.patch(`${envConfig.PLATFORM_SERVER_URL}/v2/ugc/settings/${id}`, data, true);

export {
  fetchUgcData,
  fetchUgcSettings,
  sendUserAnswer,
  updateUgcSettings,
};
